import React from 'react';
import ZipCodes from '../_libs/zip-codes';

const CustomerAddress = ({ isSingleOption }) => {
  const zipCode = ZipCodes.load();
  function message() {
    return isSingleOption
      ? "How you'll get this item:"
      : 'How do you want your item delivered?';
  }
  return (
    <>
      <h4>{message()}</h4>
    </>
  );
};

export default CustomerAddress;
